import { createCollectionCalendarRoutesMap } from './collection-calendar'
import { pathJoin } from '../../../utils'

export const createProjectIdRoutesMap = (prefix: string) => ({
  'collection-calendar': pathJoin(prefix)('collection-calendar').chainMapAuto(
    createCollectionCalendarRoutesMap
  ),
})
